import { useFigureCompositionStore } from '@/store/figure-composition';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

export function FigureTitle() {
  const { currentComposition, setTitle } = useFigureCompositionStore();

  if (!currentComposition) return null;

  return (
    <div className="space-y-1">
      <Label className="text-sm text-muted-foreground">Title</Label>
      <Input
        className="mt-1 h-10"
        value={currentComposition.title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Optional figure title"
      />
    </div>
  );
}


